import bgMin from './bg-min.png';
import sponsorA from './sponsor_1-min.png';
import sponsorB from './sponsor_2-min.png';
import sponsorC from './sponsor_3-min.png';
import sponsorD from './sponsor_4-min.png';
import sponsorE from './sponsor_5-min.png';

const Images = {
    bgMin,
    sponsorA,
    sponsorB,
    sponsorC,
    sponsorD,
    sponsorE,
}

export default Images;